/**
 * Decides which hole the compact score summary should display.
 *
 * Hole indexes are zero-based. A null result means there is no hole summary
 * to display (for example, no completed holes on a read-only device).
 */
export function resolveSummaryHole(event) {
    switch (event.type) {
        case "initial":
            if (event.lastCompletedHoleIndex < 0) {
                return event.canEditScores ? 0 : null;
            }
            return event.lastCompletedHoleIndex;
        case "local-save":
            if (event.lastCompletedHoleIndex < 0)
                return null;
            // A historical correction stays on the hole that was deliberately
            // edited. If clearing a score moved round progress backward, do not
            // leave the summary positioned beyond the new last completed hole.
            return Math.min(event.editedHoleIndex, event.lastCompletedHoleIndex);
        case "snapshot":
            if (event.lastCompletedHoleIndex < 0) {
                return event.canEditScores ? 0 : null;
            }
            if (event.currentDisplayedHoleIndex === null) {
                return event.lastCompletedHoleIndex;
            }
            // Follow genuine round-progress changes on remote devices. This advances
            // everyone when a new hole is completed and moves everyone backward when
            // the current last hole is cleared. If round progress did not change, the
            // snapshot represents a historical correction or some other data refresh,
            // so preserve the hole this device is intentionally viewing.
            if (event.lastCompletedHoleIndex !==
                event.previousLastCompletedHoleIndex) {
                return event.lastCompletedHoleIndex;
            }
            return event.currentDisplayedHoleIndex;
        case "cancel":
            return event.lastCompletedHoleIndex >= 0
                ? event.lastCompletedHoleIndex
                : null;
    }
}
//# sourceMappingURL=ScoreSummaryNavigation.js.map